export default __webpack_public_path__ + "static/media/icon_companies.00a56b41.svg";